import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
export const myToastErr = (e,reject ="") => {
  Toast({
    message: e.msg ? `${e.msg}[${e.status}]` : "网络错误！",
    position: "bottom",
    duration: 1000
  });
  reject && setTimeout(()=>{
    reject
  },1500)
};
export const checkState = (e, type = 0,tips = true) => {
  if (e && Number(e.status) !== 0) {
    if(tips){
      Toast({
        message: e.msg ? `${e.msg}` : "网络错误！",
        position: "bottom",
        duration: 1500
      });
    }
    if (type == 1) {
      return e;
    }
  } else {
    Indicator.close();
    return e;
  }
};
export const checkHttps = (e, reject) => {
  if (e == "网络开小差～，刷新试试") {
    Indicator.open("网络错误！");
    setTimeout(() => {
      Indicator.close();
    }, 1000);
    reject;
  }
};
